import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environment';

@Injectable({ providedIn: 'root' })
export class NotificationInfoService {
  private http = inject(HttpClient);
  private env = inject(environment);

  public showNotificationMessage() {
    return this.http.get<boolean>(
      `${this.env.etjansterCommonApiUrl}/notificationmessage/show`,
    );
  }
}
